export default "__VITE_ASSET__CWbv9I4z__"